import React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSession } from 'next-auth/react';
import QuestionForm from '../common/subcomponents/QuestionForm';

const Frame = styled('div')(({ $backgroundColor }) => ({
  background: $backgroundColor,
  '@media screen and (min-width: 992px)': {
    padding: '25px 0 0 0',
  },
  '@media screen and (max-width: 991px)': {
    marginTop: '20px',
    padding: '20px 0 0 0',
  },
}));

const Container = styled('div')(({ $session }) => ({
  position: 'relative',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '@media screen and (min-width: 992px)': {
    margin: '25px auto 0 auto',
    flexDirection: 'row',
    height: $session?.user ? '550px' : '640px',
    paddingBottom: '25px',
  },
  '@media screen and (max-width: 991px)': {
    justifyContent: 'normal',
    padding: 0,
    margin: '1px auto 0 auto',
    flexDirection: 'column',
    height: $session?.user ? '550px' : '820px',
  },
}));

const TitleContainer = styled('div')({
  zIndex: 100,
  display: 'flex',
  justifyContent: 'left',
  alignItems: 'center',
  '@media screen and (min-width: 1200px)': {
    position: 'absolute',
    right: '14%',
    top: '38%',
    flexDirection: 'row',
    width: '400px',
  },
  '@media screen and (max-width: 1199px)': {
    position: 'absolute',
    right: '-34%',
    top: '38%',
    flexDirection: 'row',
    width: '400px',
  },
  '@media screen and (max-width: 991px)': {
    position: 'relative',
    right: 0,
    top: 0,
    flexDirection: 'column',
    margin: '5px auto',
    width: '85%',
  },
});

const Title = styled('div')({
  display: 'flex',
  alignItems: 'center',
  fontWeight: 600,
  textTransform: 'uppercase',
  '@media screen and (min-width: 992px)': {
    margin: '10px 15px',
    fontSize: '2.3rem',
    lineHeight: '2.55rem',
  },
  '@media screen and (max-width: 991px)': {
    justifyContent: 'normal',
    margin: 0,
    fontSize: '1.825rem',
    lineHeight: '2.025rem',
  },
});

const AccentImage = styled('img')({
  position: 'absolute',
  left: '47%',
  bottom: 0,
  width: 'auto',
  width: '591px',
  opacity: 0.3,
  '@media screen and (max-width: 991px)': {
    display: 'none',
  },
});

const FormContainer = styled('div')(({ $session }) => ({
  display: 'flex',
  alignItems: 'center',
  zIndex: 30,
  '@media screen and (min-width: 992px)': {
    padding: '0 80px 0 20px',
    position: 'absolute',
    left: '2%',
    top: $session?.user ? '10px' : '40px',
    justifyContent: 'flex-start',
    width: '675px',
    height: '550px',
  },
  '@media screen and (max-width: 991px)': {
    padding: '110px 10px 0 10px',
    justifyContent: 'center',
    width: '100%',
    height: '600px',
  },
}));

const AskTheTrainerForm = ({ module }) => {
  const { fields } = module;
  const theme = useTheme();
  const { data: session } = useSession();

  return (
    <Box
      sx={{
        width: '100%',
        ml: 'auto',
        mr: 'auto',
        maxWidth: { sm: '540px', md: '768px', lg: '1180px', xl: '1180px' },
      }}
    >
      <Frame $backgroundColor={fields.backgroundColor}>
        <Container $session={session}>
          <TitleContainer>
            <Title>
              {fields.titleLine1}
              <br />
              {fields.titleLine2}
            </Title>
          </TitleContainer>
          <FormContainer $session={session}>
            <QuestionForm buttonColor={theme.palette.primary.light} />
          </FormContainer>
          {fields.accentImage && (
            <AccentImage
              src={fields.accentImage?.url}
              alt={fields.accentImage?.label}
            ></AccentImage>
          )}
        </Container>
      </Frame>
    </Box>
  );
};

export default AskTheTrainerForm;
